export default "__VITE_ASSET__fdc7be8d__"